import { ReactNode } from 'react';
import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip';

const Wrapper = styled.button`
  border-radius: 50%;
  padding: ${({ theme }) => theme.spacing.values.half};
  background-color: transparent;
  border: 0;
  margin: 0;
  height: ${({ theme }) => theme.spacing.values.base};
  width: ${({ theme }) => theme.spacing.values.base};
  box-sizing: content-box;
  color: #717171;
  outline: none;

  &:hover {
    background-color: #f3f4f5;
  }

  &:focus {
    outline-style: solid;
    outline-color: #c3c3c5;
  }
`;

type TextAreaFieldToolbarButtonProps = {
  onClick: () => void;
  tooltip: string;
  icon: ReactNode;
};

export const TextAreaFieldToolbarButton = ({
  icon,
  onClick,
  tooltip,
}: TextAreaFieldToolbarButtonProps) => {
  return (
    <Tooltip tooltipContent={tooltip}>
      <Wrapper onClick={onClick} data-test="text-area-field--toolbar-button">
        {icon}
      </Wrapper>
    </Tooltip>
  );
};
